import Button from "@mui/material/Button";
import Dialog from "@mui/material/Dialog";
import DialogContent from "@mui/material/DialogContent";
import DialogTitle from "@mui/material/DialogTitle";
// import TextField from "@mui/material/TextField";
import { useSnackbar } from "notistack";
import React from "react";
import { useHistory } from "react-router-dom";
import API from "@/api/serverCall";
import "./style.css";

type EditPasswordDialogProps = {
	openModal: boolean;
	handleModalClose: () => void;
};

const DeleteAccountDialog: React.FC<EditPasswordDialogProps> = ({
	openModal,
	handleModalClose,
}) => {
	const { enqueueSnackbar } = useSnackbar();
	const history = useHistory();
	const deleteAppFunc = () => {
		try {
			API.DELETE<string>({
				link: `/user/withdraw`, // 두잉랩서버 로그인토큰발급 api임
			})
				.then(() => {
					handleModalClose();
					history.push("/auth/login");
					enqueueSnackbar("계정이 삭제되었습니다", {
						variant: "info",
					});
				})
				.catch((error) => {
					if (error.response.status === 303) {
						enqueueSnackbar("진행중인 플랜이 있어 삭제가 불가합니다", {
							variant: "info",
						});
					} else if (error.response.status === 409) {
						enqueueSnackbar("남아있는 앱이 있어 삭제가 불가합니다.", {
							variant: "info",
						});
					} else {
						enqueueSnackbar("일시적 오류입니다", {
							variant: "info",
						});
					}
				});
		} catch (error) {
			console.error(error);
		}
	};

	return (
		<Dialog onClose={handleModalClose} open={openModal} fullWidth={true}>
			<DialogTitle sx={{ fontWeight: "bold" }}>정말 삭제 하시겠습니까?</DialogTitle>
			<DialogContent>
				<div style={{ paddingTop: "1rem" }}>
					<h4 style={{ marginBottom: "1rem" }}>
						현재 오너의권할을 가지고 있습니다
					</h4>
					<p
						style={{
							lineHeight: "1.2rem",
							color: "#676767",
							marginBottom: "1rem",
						}}
					>
						아래의 조건을 모두 충족하였습니다
					</p>
					<span
						style={{
							display: "block",
							textDecoration: "line-through",
							color: "rgb(231, 5, 5)",
						}}
					>
						현재 진행중인 구독 취소하기
					</span>
					<span
						style={{
							display: "block",
							textDecoration: "line-through",
							color: "rgb(231, 5, 5)",
						}}
					>
						구독 종료 시점까지 기다리기
					</span>
					<span
						style={{
							display: "block",
							textDecoration: "line-through",
							color: "rgb(231, 5, 5)",
						}}
					>
						계정에 속해있는 앱(들) 삭제하기
					</span>
					<span
						style={{
							display: "block",
							textDecoration: "line-through",
							color: "rgb(231, 5, 5)",
						}}
					>
						계정에 속해있는 멤버(들)삭제하기
					</span>
				</div>
				<div
					style={{
						display: "flex",
						justifyContent: "flex-end",
						marginTop: "5rem",
					}}
				>
					<Button
						variant="outlined"
						sx={{
							color: "#747474",
							borderColor: "#CCCCCC",
							marginRight: "0.5rem",
						}}
						onClick={handleModalClose}
					>
						취소
					</Button>
					<Button
						className="deleteButton"
						variant="contained"
						sx={{ backgroundColor: "rgb(231, 5, 5)", color: "white" }}
						onClick={(e) => {
							deleteAppFunc();
						}}
					>
						삭제
					</Button>
				</div>
			</DialogContent>
		</Dialog>
	);
};

export default DeleteAccountDialog;
